import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import { Table, TableColumn } from 'element-ui';
import MedalDecider from '@/components/shared/medals/club/decider/decider.vue'

export default {
    name: 'ClubTableList',
    props: {
        data: Array,
        isProcessing: Boolean,
        from: Number,
        to: Number,
        total: Number,
        page: Number,
        perPage: Number,
    },
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        'medal-decider': MedalDecider

    },
    data() {
        return {
            standardTypes: [{ id: null, label: 'None' }, { id: 1, label: 'Gold' }, { id: 2, label: 'Silver' }, { id: 3, label: 'Bronze' }]
        }
    },
    computed: {
    },
    methods: {
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 1000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        init() {
            this.load();
        },
        load() {

        },
        rowClick(data) {
            this.$emit("update:currentClubId", data.id);
            this.$emit("update:currentStandardType", data.applicationStandardType);
            this.$emit("update:currentClubName", data.clubName);
        },
        updateStatus(clubId, standardType) {
            self = this
            self.$emit("update:isProcessing ", true);
            request.updateStandardType(clubId, standardType)
                .then(response => {
                    self.$emit("update:isProcessing ", false);
                    if (response && response.body && response.body.isSuccess) {
                        EventBus.$emit('club-list-reload');
                    } else {
                        self.$showError(5000);
                    }
                },
                    () => {
                        self.$emit("update:isProcessing ", false);
                        self.$showError(5000);
                    })
        }
        
    },
    mounted() {
        this.init();
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/clubs-list/table/table.js